import { useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Box,
    Stack,
} from "@mui/material";
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    Add as AddIcon,
} from "@mui/icons-material";

function AIPrompts() {
    const [prompts, setPrompts] = useState([
        {
            id: 1,
            name: "Asset Prompt",
            prompt: "Analyze the following document and provide a detailed description of the asset. I want to know the asset name, description, what it is capable of, and any other relevant information."
        },
        {
            id: 2,
            name: "Requirements Prompt",
            prompt: "Analyze the following document and provide a detailed description of the requirements. I want to know the general overview of the requirements, a more detailed explanation for them, and your rationale for them."
        },
    ]);

    const [promptDialogOpen, setPromptDialogOpen] = useState(false);
    const [selectedPrompt, setSelectedPrompt] = useState(null);
    const [promptFormData, setPromptFormData] = useState({
        name: "",
        prompt: ""
    });

    const handlePromptDialogOpen = (prompt = null) => {
        if (prompt) {
            setSelectedPrompt(prompt);
            setPromptFormData({
                name: prompt.name,
                prompt: prompt.prompt
            });
        } else {
            setSelectedPrompt(null);
            setPromptFormData({
                name: "",
                prompt: ""
            });
        }
        setPromptDialogOpen(true);
    };

    const handlePromptDialogClose = () => {
        setPromptDialogOpen(false);
        setSelectedPrompt(null);
    };

    const handlePromptFormChange = (field) => (event) => {
        setPromptFormData(prev => ({
            ...prev,
            [field]: event.target.value
        }));
    };

    const handleDeletePrompt = (promptId) => {
        setPrompts(prev => prev.filter(prompt => prompt.id !== promptId));
    };

    const handleSavePrompt = () => {
        if (selectedPrompt) {
            setPrompts(prev => prev.map(prompt => 
                prompt.id === selectedPrompt.id 
                    ? { ...prompt, ...promptFormData }
                    : prompt
            ));
        } else {
            const newPrompt = {
                id: prompts.length + 1,
                ...promptFormData
            };
            setPrompts(prev => [...prev, newPrompt]);
        }
        handlePromptDialogClose();
    };

    return (
        <>
            <TableContainer>
                <Table>
                    <TableHead sx={{ display: "table-header-group" }}>
                        <TableRow>
                            <TableCell sx={{ color: "text.main" }}>Name</TableCell>
                            <TableCell sx={{ color: "text.main" }}>Prompt</TableCell>
                            <TableCell sx={{ color: "text.main", width: 120 }}>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {prompts.map((prompt) => (
                            <TableRow key={prompt.id}>
                                <TableCell>{prompt.name}</TableCell>
                                <TableCell>{prompt.prompt}</TableCell>
                                <TableCell>
                                    <IconButton 
                                        onClick={() => handlePromptDialogOpen(prompt)}
                                    >
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton 
                                        color="error"
                                        onClick={() => handleDeletePrompt(prompt.id)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Box sx={{ 
                mt: 2,
                display: 'flex',
                justifyContent: 'flex-end'
            }}>
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => handlePromptDialogOpen()}
                >
                    Add Prompt
                </Button>
            </Box>

            {/* Prompt Dialog */}
            <Dialog 
                open={promptDialogOpen} 
                onClose={handlePromptDialogClose}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    {selectedPrompt ? "Edit Prompt" : "Add Prompt"}
                </DialogTitle>
                <DialogContent>
                    <Stack spacing={2} sx={{ mt: 2 }}>
                        <TextField
                            autoFocus
                            label="Name"
                            fullWidth
                            value={promptFormData.name}
                            onChange={handlePromptFormChange('name')}
                            sx={{
                                '& .MuiInputBase-root': {
                                    height: '56px',
                                }
                            }}
                        />
                        <TextField
                            label="Prompt"
                            fullWidth
                            multiline
                            rows={4}
                            value={promptFormData.prompt}
                            onChange={handlePromptFormChange('prompt')}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handlePromptDialogClose}>Cancel</Button>
                    <Button 
                        variant="contained" 
                        onClick={handleSavePrompt}
                    >
                        {selectedPrompt ? "Save Changes" : "Add Prompt"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default AIPrompts; 